import { render, staticRenderFns } from "./TabAboutUs.vue?vue&type=template&id=ed71bf6e&"
import script from "./TabAboutUs.vue?vue&type=script&lang=js&"
export * from "./TabAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports